import { useState, useContext, useEffect } from "react";
import landingStyle from "../styles/landing.module.scss";
import LoginFunction from "../utilities/LoginFunction";
import { UserContext } from "../context/UserContext";
import useToken from "../utilities/hooks/useToken";
import { useNavigate } from "react-router-dom";

const ASIATAN_LOGO = "https://matlib.co/images/asiatanLogo.png";
const TECTUFF_LOGO = "https://matlib.co/images/tectuffLogo.png";

function LoginForm() {
  const { changeUserInformation, userInformation, changelogOutUser } =
    useContext(UserContext);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [remotePassword, setRemotePassword] = useState("");
  const [userInfo, setUserInfo] = useState([]);
  const { token, setToken } = useToken();
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  //let [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  const handleLogOutUser = () => {
    changelogOutUser();
  };

  const normalizeLoginIdentifier = (value) => value.trim().toLowerCase();

  const handleSubmit = (e) => {
    e.preventDefault();
    const loginIdentifier = normalizeLoginIdentifier(email);

    if (!loginIdentifier) {
      setMessage("Enter your email or ID");
      return;
    }

    setLoading(true);
    const login = LoginFunction(loginIdentifier);
    login.then((response) => {
      if (response.id) {
        setUserInfo(response);
        setToken(response.accessToken);
        setRemotePassword(response.password);
        setMessage("");
        setLoading(false);
      } else {
        setMessage("account not found");
        setLoading(false);
      }
    });
  };

  useEffect(() => {
    if (
      userInfo.userType === "vendor" &&
      token?.length > 20 &&
      userInfo.password !== ""
    ) {
      if (password === remotePassword) {
        changeUserInformation({
          userId: userInfo.id,
          userType: userInfo.userType,
          vendor: userInfo.brand,
          userName: userInfo.userName,
          isLoggedIn: true,
        });
        navigate("/library");
      } else {
        setMessage("");
        if (password.length && password !== remotePassword) {
          setMessage("password incorrect");
        }
      }
    }
    if (
      userInfo.userType === "vendor" &&
      token?.length > 20 &&
      userInfo.password === ""
    ) {
      if (password === remotePassword) {
        changeUserInformation({
          userId: userInfo.id,
          userType: userInfo.userType,
          vendor: userInfo.brand,
          userName: userInfo.userName,
          isLoggedIn: true,
        });
        navigate("/library");
      }
    }
    if (
      userInfo.userType === "designer" &&
      token?.length > 20 &&
      userInfo.password === ""
    ) {
      changeUserInformation({
        userId: userInfo.id,
        userType: userInfo.userType,
        vendor: userInfo.brand,
        userName: userInfo.userName,
        isLoggedIn: true,
      });
      navigate("/library");
    }
    // eslint-disable-next-line
  }, [userInfo]);

  const inputField = (e) => {
    setEmail(e.target.value);
    setMessage("");
  };
  const passwordField = (e) => {
    setPassword(e.target.value);
    setMessage("");
  };

  const { isLoggedIn, userName } = userInformation;

  if (userName && isLoggedIn) {
    return (
      <div className={landingStyle.sessionPanel}>
        <div className={landingStyle.vendorLogos}>
          <img src={ASIATAN_LOGO} alt="asiatan" />
          <img src={TECTUFF_LOGO} alt="tectuff" />
        </div>
        <div className={landingStyle.loginViewContent}>
          <p className={landingStyle.stateLabel}>Current Session</p>
          <h3 className={landingStyle.loginViewHeading}>
            You are currently logged in as {userInformation.userName} from{" "}
            {userInformation.vendor}
          </h3>
          <div className={landingStyle.sessionActionGroup}>
            <button
              className="button-highlight"
              onClick={() => navigate("/library")}
            >
              go to Library
            </button>
            <button className="button-highlight" onClick={handleLogOutUser}>
              Log out
            </button>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className={landingStyle.loginView}>
      <div className={landingStyle.vendorLogos}>
        <img src={ASIATAN_LOGO} alt="asiatan" />
        <img src={TECTUFF_LOGO} alt="tectuff" />
      </div>
      <form className={landingStyle.loginForm} onSubmit={handleSubmit}>
        <div className={landingStyle.formHeader}>
          <p className={landingStyle.stateLabel}>Sign In</p>
          <h3>Welcome back</h3>
          <p>Sign in with your email or ID.</p>
        </div>

        <div className={landingStyle.loginInputGroup}>
          <label htmlFor="email">Email or ID</label>
          <input
            id="email"
            name="email"
            type="text"
            placeholder="Email or ID"
            autoComplete="username"
            onChange={inputField}
          />
          {userInfo.userType === "vendor" ? (
            <>
              <label htmlFor="password">Password</label>
              <input
                id="password"
                name="password"
                type="password"
                placeholder="Enter password"
                autoComplete="new-password"
                onChange={passwordField}
              />
            </>
          ) : null}
          {message !== "" ? (
            <div className={landingStyle.loginErrorMessage}>{message}</div>
          ) : null}
        </div>
        {loading ? (
          <div className={landingStyle.loginLoading} aria-live="polite">
            <div className={landingStyle.loadingDots} aria-hidden="true">
              <span></span>
              <span></span>
              <span></span>
            </div>
            <span className={landingStyle.loadingLabel}>Checking access</span>
          </div>
        ) : null}
        <button
          className={`${landingStyle.button} ${!email.trim() ? landingStyle.buttonDisabled : ""}`}
          type="submit"
          disabled={!email.trim()}
        >
          {loading ? "Signing in..." : "Login"}
        </button>
      </form>
    </div>
  );
}

export default LoginForm;
